import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePayPalScriptReducer } from '@paypal/react-paypal-js';
import IntegrationPageSectionContext from './StateManagement/IntegrationPageSectionContext';
import SectionContent from './SectionContent';

// This component handles reset of JS SDK using usePayPalScriptReducer for SDK config changes
const SectionContentWrapper = ({ ecmIntegContent = {} }) => {
  const {
    SdkConfigurator: {
      sdkSettings: {
        clientId,
        buyerCountry,
        sdkBaseUrl,
        intent,
        currency,
        enableFunding,
        disableFunding
      }
    }
  } = useContext(IntegrationPageSectionContext);

  const [{ options }, dispatch] = usePayPalScriptReducer();

  const filter = (obj, fn) => {
    const entries = Object.entries(obj).filter(fn);
    return Object.fromEntries(entries);
  };

  const pickBy = (obj, fn) => filter(obj, ([key, val]) => fn(val, key));

  useEffect(() => {
    const newOptions = pickBy(
      {
        clientId,
        buyerCountry,
        intent,
        currency,
        enableFunding,
        disableFunding
      },
      (val) => val !== null && val !== undefined
    );

    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        sdkBaseUrl,
        ...newOptions
      }
    });
  }, [clientId, buyerCountry, intent, currency, enableFunding, disableFunding]);

  return <SectionContent ecmIntegContent={ecmIntegContent} />;
};

SectionContentWrapper.propTypes = {
  ecmIntegContent: PropTypes.object.isRequired
};

export default SectionContentWrapper;
